import {MODELS} from '../../../../Apis/Models';
import {TABLES} from '../../../../Apis/Tables';
import {useEffect, useLayoutEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParamsContextProvider} from '../../../../hooks/ParamsContextProvider';
import {MODEL_CONTEXT, SUB_VIEW_MODEL, TABS_FOODIE} from '../Model/Models';
import {useLocation, useNavigate} from 'react-router-dom';
import routes from '../../../../Routes/routes';
import {useDispatch, useSelector} from 'react-redux';
import {  permissionObj  } from '../../../../Helpers/permission';
import {  ACTION_MODEL  } from '../../../../Helpers/ActionModel';
import {ATTENDANCE_MODES} from "../Manage/Models/Model";
import {VIEW_TYPE} from "../../../../enums/ViewType";
import HandleExportApp from "../../../Modals/Functionality/HandleExportApp";
import {MEAL_FORECAST_EXPORT_HEADERS} from "../Menu/Model/Model";
import {GetServiceById} from "../../../../reduxToolkit/Employee/EmployeeApi";
import {SERVICE} from "../../Company/Employees/Model/Models";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 */
const FoodieMainApp = () => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    let {state} = location;
    const currentTab = state?.currentTab;
    const currentSubView = state?.currentSubView;
    const { paramsContext, setParamsContext } = useParamsContextProvider();
    const [moduleId, setModuleId] = useState(null);
    const [option, setOption] = useState(null);
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const [view, setView] = useState('');
    const [activeStep, setActiveStep] = useState(null);
    const [steps, setSteps] = useState([]);
    const [criteria, setCriteria] = useState();
    const [finalArray, setFinalArray] = useState([]);
    const [modified, setModified] = useState(false);
    const [filterDialogShow, setFilterDialogShow] = useState(false);
    const [bodyForExport, setBodyForExport] = useState(''); // Data to export
    const [subView, setSubView] = useState(null); // Variable to manage subviews and permissions. When entering the module, it is necessary to initialize the variable (if applicable, used SUB_VIEW_MODEL).
    const [subViewChild, setSubViewChild] = useState(VIEW_TYPE.LIST.name);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [render, setRender] = useState('');
    const [selectedOption, setSelectedOption] = useState(ATTENDANCE_MODES.daily);
    const [isPilgrimsValidation, setIsPilgrimsValidation] = useState(false);
    const [exportModuleDataOption, setExportModuleDataOption] = useState(false);

    /**
     * Hook to initialize the Context only if it is null or doesn't exist.
     */
    useLayoutEffect(() => {
        if (!paramsContext || paramsContext === null) {
            setParamsContext({ ...MODEL_CONTEXT });
        }

        dispatch(GetServiceById(SERVICE.PILGRIMS)).then(
            ({ payload: {data: { data, success }}}) => {
                if (success === true) {
                    setIsPilgrimsValidation(data?.validation)
                }
            },
        );
    }, []);

    /**
     * Hook to display the tabs if the user has the corresponding permissions.
     */
    useLayoutEffect(() => {
        let activeTab = null;
        const stepConfig = [
            { tab: TABS_FOODIE.SCHEDULES.TRANS, perm: [permissionObj?.WEB_FOODIE_SHIFT_READ, permissionObj?.WEB_FOODIE_MEAL_TIME_READ, permissionObj?.WEB_FOODIE_ACCESS_READ], index:TABS_FOODIE.SCHEDULES.INDEX },
            { tab: TABS_FOODIE.CAFETERIAS.TRANS, perm: [permissionObj?.WEB_FOODIE_CAFETERIA_READ], index:TABS_FOODIE.CAFETERIAS.INDEX },
            { tab: TABS_FOODIE.MENUS.TRANS, perm: [permissionObj?.WEB_FOODIE_MENU_READ, permissionObj.WEB_FOODIE_MEAL_FORECAST_READ], index:TABS_FOODIE.MENUS.INDEX },
            { tab: TABS_FOODIE.DISHES.TRANS, perm: [permissionObj?.WEB_FOODIE_ITEM_READ], index:TABS_FOODIE.DISHES.INDEX },//Change permission
            { tab: TABS_FOODIE.INGREDIENTS.TRANS, perm: [permissionObj?.WEB_INGREDIENT_READ], index:TABS_FOODIE.INGREDIENTS.INDEX },
            { tab: TABS_FOODIE.REQUESTS.TRANS, perm: [permissionObj?.WEB_FOODIE_REQUEST_READ, permissionObj?.WEB_FOODIE_REQUEST_HISTORY_READ], index:TABS_FOODIE.REQUESTS.INDEX },
            { tab: TABS_FOODIE.MANAGE.TRANS, perm: [permissionObj?.WEB_FOODIE_ATTENDANCE_READ, permissionObj?.WEB_FOODIE_DEPARTMENT_POLICIES_READ, permissionObj?.WEB_TOTAL_MEALS_READ, permissionObj?.WEB_FOODIE_MANAGE_SETTINGS_READ], index:TABS_FOODIE.MANAGE.INDEX },// include permission for dinning attendance
        ];

        const auxStep = stepConfig.reduce((acc, { tab, perm, index }) => {
            const hasPermission = DEV || perm.some((p) => permission?.includes(p));
            if (hasPermission) {
                acc.push({ label: t(tab), index: index });
                if (activeTab === null) activeTab = index;
            }
            return acc;
        }, []);

        setSteps(auxStep);

          if (activeTab !== null && activeStep === null) {
              handleStepChange(activeTab);
          }
    }, [t, permission]);

    /**
     * Hook to return to the current tab based on the index stored in the Context.
     */
    useEffect(() => {
        // The tab of the state wins: it carries the subview the user is coming back to,
        // and the context only keeps the tab index
        if (currentTab) return;

        if (paramsContext?.tabIndex !== null && typeof paramsContext?.tabIndex !== 'undefined')
            handleStepChange(paramsContext?.tabIndex);
    }, []);

    /**
     * Effect hook that updates the current step based on the active tab.
     *
     * This hook listens for changes in the URL location and triggers
     * `handleStepChange` whenever a valid `currentTab` value is present.
     */
    useLayoutEffect(() => {
        if (currentTab) handleStepChange(currentTab);
    }, [location]);

    /**
     * The index of the active tab is stored in the context, so that the user can return to the same tab in case the view is redirected.
     * @param step
     */
    const handleStepChange = (step) => {
        setActiveStep(step);
        if (setParamsContext)
            setParamsContext((prev) => ({
                ...prev,
                tabIndex: step,
            }));
        setView('');
        setFinalArray([]);
        setRender('');
        setSearch(false);
        setSelectedOption(ATTENDANCE_MODES.daily);
        // Coming back from a detail the subview travels in the state, so it is restored
        // instead of being reset and losing the tab the user came from. It only belongs
        // to the tab of the state: on any other tab it would leave the new tab without a view
        const isReturningToTab = !!currentSubView && step === currentTab;
        setSubView(isReturningToTab ? currentSubView : null);

        if(!isReturningToTab)
            navigate(location.pathname, { replace: true, state: {} });

        switch (step) {
            case TABS_FOODIE.SCHEDULES.INDEX:
                setModuleId(MODELS.FOODIE_SHIFT);
                setOption(TABLES.FOODIE_SHIFT);
                break;

            case TABS_FOODIE.CAFETERIAS.INDEX:
                setModuleId(MODELS.FOODIE_CAFETERIA);
                setOption(TABLES.FOODIE_CAFETERIA);
                break;

            case TABS_FOODIE.MENUS.INDEX:
                setModuleId(MODELS.FOODIE_MENU);
                setOption(TABLES.MENU);
                break;

            case TABS_FOODIE.DISHES.INDEX:
                setModuleId(MODELS.FOODIE_ITEM);
                setOption(TABLES.DISH);
                break;

            case TABS_FOODIE.INGREDIENTS.INDEX:
                setModuleId(MODELS.INGREDIENT);
                setOption(TABLES.INGREDIENT);
                break;

            case TABS_FOODIE.REQUESTS.INDEX:
                break;

            case TABS_FOODIE.MANAGE.INDEX:
                setModuleId(MODELS.FOODIE);
                setOption(TABLES.FOODIE);
                break;
            default:
                setModuleId(null);
                setOption(null);
                break;
        }
    };

    /**
     * Function for the create and/or delete action, where the modalDelete and modalCreate variables can be activated and/or a view redirection can be performed.
     * @param Boolean isCreate: If the variable is true, it indicates that the action was triggered from the create button; otherwise, the action was triggered from the delete button.
     */
    const handleCreateDelete = (action = ACTION_MODEL.CREATE) => {
        switch (paramsContext.tabIndex) {
            case TABS_FOODIE.SCHEDULES.INDEX:
                if (setParamsContext) {
                    if (action === ACTION_MODEL.CREATE) {
                        if (subView === SUB_VIEW_MODEL.SCHEDULE.SHIFTS) {
                            navigate(routes.foodieShift.create);
                        } else {
                            setParamsContext((prev) => ({
                                ...prev,
                                modalCreate: true,
                            }));
                        }
                    } else {
                        setParamsContext((prev) => ({
                            ...prev,
                            modalDelete: true,
                        }));
                    }
                }
                break;

            case TABS_FOODIE.CAFETERIAS.INDEX:
                if (setParamsContext) {
                    if (action === ACTION_MODEL.CREATE) {
                        navigate(`${routes.foodieCafeteria.create}`); //  Redirects to the view for updating an ingredient
                    } else {
                        // The modalDelete variable from the Context is activated to display the delete modal. This variable is listened to by the corresponding ingredient component.
                        setParamsContext((prev) => ({
                            ...prev,
                            modalDelete: true,
                        }));
                    }
                }
                break;

            case TABS_FOODIE.MENUS.INDEX:
                if (setParamsContext) {
                    if (action == ACTION_MODEL.CREATE) {
                        navigate(`${routes.foodieMenu.create}`);
                    } else {
                        setParamsContext((prev) => ({
                            ...prev,
                            modalDelete: true,
                        }));
                    }
                }
                break;
            case TABS_FOODIE.DISHES.INDEX:
                if (setParamsContext) {
                    if (action === ACTION_MODEL.CREATE) {
                        navigate(`${routes.foodieDish.create}`); //  Redirects to the view for creating dish
                    } else {
                        setParamsContext((prev) => ({
                            ...prev,
                            modalDelete: true,
                        }));
                    }
                }
                break;

            case TABS_FOODIE.INGREDIENTS.INDEX:
                if (setParamsContext) {
                    if (action === ACTION_MODEL.CREATE) {
                        if(view != ''){
                            navigate(`${routes.foodieIngredient.addEdit}`, { state: { view: view } });
                        }else{
                            navigate(`${routes.foodieIngredient.addEdit}`);
                        }
                    } else {
                        // The modalDelete variable from the Context is activated to display the delete modal. This variable is listened to by the corresponding ingredient component.
                        setParamsContext((prev) => ({
                            ...prev,
                            modalDelete: true,
                        }));
                    }
                }
                break;

            case TABS_FOODIE.REQUESTS.INDEX:
                if (setParamsContext) {
                    setParamsContext((prev) => ({
                        ...prev,
                        modalCreate: true,
                    }));
                }
                break;

            case TABS_FOODIE.MANAGE.INDEX:
                navigate(routes.foodieManage.manage);
                break;

            default:
                break;
        }
    };

    /**
     * Function for the create and/or delete action, where the modalDelete and modalCreate variables can be activated and/or a view redirection can be performed.
     * @param Boolean isCreate: If the variable is true, it indicates that the action was triggered from the create button; otherwise, the action was triggered from the delete button.
     */
    const handleUpdate = () => {
        switch (paramsContext.tabIndex) {
            case TABS_FOODIE.MANAGE.INDEX:
                if(subView == SUB_VIEW_MODEL.MANAGE.SETTINGS && setParamsContext){
                    setParamsContext(prev => ({
                        ...prev, btnUpdate: ACTION_MODEL.UPDATE
                    }));
                }
                break;

            default:
                break;
        }
    };

    /**
     * Function to validate permissions for the create and delete buttons. It can also be applied to import, export, and search buttons.
     * If no permission is assigned or the tabIndex variable from the Context is null, the button is import { ACTION_MODEL } from './../../../../Helpers/ActionModel';
not displayed.
     * @param array list: List of permissions based on the active tab.
     * @returns {boolean|*}
     */
    const permissionButtons = (list) => {
        if (paramsContext?.tabIndex == null) {
            return false;
        }
        const permissionRequired = list[paramsContext?.tabIndex];

        if (!permissionRequired) {
            return false;
        }
        return DEV || permission?.includes(permissionRequired);
    };

    const {
        handleDownloadExcelAttendance,
        handleDownloadPDFAttendance
    } = HandleExportApp( {
        body: bodyForExport ,
        selectedOptions: MEAL_FORECAST_EXPORT_HEADERS,
        search,
        moduleId,
        option,
        searchElement
    });



    return {
        t,
        DEV,
        permission,
        navigate,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        view,
        setView,
        criteria,
        setCriteria,
        bodyForExport,
        setBodyForExport,
        moduleId,
        setModuleId,
        option,
        setOption,
        activeStep,
        setActiveStep,
        steps,
        paramsContext,
        handleStepChange,
        handleCreateDelete,
        handleUpdate,
        permissionButtons,
        subView,
        setSubView,
        subViewChild,
        setSubViewChild,
        finalArray,
        setFinalArray,
        setFilterDialogShow,
        filterDialogShow,
        modified,
        setModified,
        simpleSearch,
        setSimpleSearch,
        render, setRender,
        selectedOption,
        setSelectedOption,
        isPilgrimsValidation,
        exportModuleDataOption,
        setExportModuleDataOption,
        handleDownloadExcelAttendance,
        handleDownloadPDFAttendance
    };
};

export default FoodieMainApp;
